import styled from "styled-components";

export const StyledDialAdditionForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
`;

export const StyledSelectContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledSelectContactPicker = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledContactCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px;
  text-transform: capitalize;
`;
